export interface SuccessResult<T> {
  success: true
  data: T
  error: null
}

interface FailureResult<T> {
  success: false
  error: T & {
    code: number | string
  }
  data: null
}

export type Result<S, F = void> = SuccessResult<S> | FailureResult<F>

export function success<T>(data?: T): SuccessResult<T> {
  return {
    success: true,
    data,
    error: null,
  }
}

export function failure(code: number | string): FailureResult<void>
export function failure<T extends {}>(code: number | string, meta: T): FailureResult<T>
export function failure(code, meta?) {
  return {
    success: false,
    error: {
      ...meta,
      code,
    },
  }
}
